/* src/components/Common/NotFound/NotFound.js */

import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import Particles from '../Particles';
import './NotFound.css';

const NotFound = () => {
  const navigate = useNavigate();
  const mainRef = useRef(null);

  const handleReturnHome = () => {
    navigate('/');
  };

  useEffect(() => {
    // Set focus to the main content for accessibility
    mainRef.current.focus();
  }, []);

  return (
    <div
      className="relative min-h-screen bg-gradient-to-b from-primary to-secondary overflow-hidden flex items-center justify-center"
      tabIndex="-1"
      ref={mainRef}
    >
      {/* Particle Effects */}
      <Particles count={60} className="absolute inset-0 z-0" />

      {/* Light Overlay */}
      <div className="light-overlay absolute inset-0 z-5"></div>

      {/* Glitchy 404 Content */}
      <div className="relative z-10 flex flex-col items-center text-center">
      <h2 className="hero layers glitch" data-text="404">
          <span className="single-path text-white">404</span>
        </h2>
        <p className="mt-6 text-xl md:text-2xl text-gray-300 max-w-md mx-auto">
          Oops!<br /> The page you are looking for doesn’t exist. Let’s get you back to safety!
        </p>
        <button
          onClick={handleReturnHome}
          className="mt-8 px-6 py-3 bg-accentBlue hover:bg-accentBlueDark text-white font-semibold rounded-md shadow-lg transition-transform transform hover:scale-110 focus:outline-none focus:ring-2 focus:ring-accentBlue"
          aria-label="Return to Home"
        >
          Return to Home
        </button>
      </div>
    </div>
  );
};

export default NotFound;
